import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const BoundingBox: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M180 240c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30zm0 510c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30zm420-330c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30zm0 510c-33.08 0-60-26.92-60-60s26.92-60 60-60 60 26.92 60 60-26.92 60-60 60zm0-90c-16.54 0-30 13.46-30 30s13.46 30 30 30 30-13.46 30-30-13.46-30-30-30zm-90-375H270v-30h210c16.57 0 30 13.43 30 30zM270 615h240v-30H300c-16.57 0-30 13.43-30 30zM165 510V270h30v210c0 16.57-13.43 30-30 30zm445-240v240h-30V300c0-16.57 13.43-30 30-30z' />
  </IconBase>
));

BoundingBox.displayName = 'BoundingBox';

export default BoundingBox;
